<template>
  <section class="course-advantages">
    <div class="container">
      <h2 class="section-title">
        <span class="title-text">课程优势</span>
        <span class="title-line"></span>
      </h2>

      <div class="advantages-grid">
        <el-card class="advantage-card" shadow="hover">
          <div class="advantage-icon">
            <el-icon :size="36"><Cpu /></el-icon>
          </div>
          <h3 class="advantage-title">零基础入门</h3>
          <p class="advantage-desc">内容由浅入深，充分考虑课程难易先后顺序，降低学习时间成本</p>
        </el-card>

        <el-card class="advantage-card" shadow="hover">
          <div class="advantage-icon">
            <el-icon :size="36"><Monitor /></el-icon>
          </div>
          <h3 class="advantage-title">面向热门岗位</h3>
          <p class="advantage-desc">覆盖座舱域、智驾域、OTA、Tbox、车身域、车载网络测试等细分岗位方向</p>
        </el-card>

        <el-card class="advantage-card" shadow="hover">
          <div class="advantage-icon">
            <el-icon :size="36"><Pointer /></el-icon>
          </div>
          <h3 class="advantage-title">直击工作流程</h3>
          <p class="advantage-desc">非枯燥技术点理论罗列，针对性讲解企业岗位实际工作开展流程细节</p>
        </el-card>

        <el-card class="advantage-card" shadow="hover">
          <div class="advantage-icon">
            <el-icon :size="36"><Connection /></el-icon>
          </div>
          <h3 class="advantage-title">车载仿真系统</h3>
          <p class="advantage-desc">大量车载仿真系统，对应企业实际项目进行实操练习，涉及密钥核心数据均有仿真</p>
        </el-card>

        <el-card class="advantage-card" shadow="hover">
          <div class="advantage-icon">
            <el-icon :size="36"><User /></el-icon>
          </div>
          <h3 class="advantage-title">VIP全程指导</h3>
          <p class="advantage-desc">VIP技术/就业全程真人指导群，技术问题随时答疑，就业问题全程跟踪</p>
        </el-card>

        <el-card class="advantage-card" shadow="hover">
          <div class="advantage-icon">
            <el-icon :size="36"><Stamp /></el-icon>
          </div>
          <h3 class="advantage-title">就业保障协议</h3>
          <p class="advantage-desc">报名即签订就业保障协议，未按保障薪资就业退还学费，真实就业案例可查</p>
        </el-card>
      </div>
    </div>
  </section>
</template>

<script setup>
// 导入课程优势所需图标
import { Cpu, Monitor, Pointer, Connection, User, Stamp } from '@element-plus/icons-vue'
</script>

<style scoped>
.container {
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

.section-title {
  text-align: center;
  margin-bottom: 40px;
  position: relative;
  padding-bottom: 15px;
}

.title-text {
  font-size: 28px;
  color: #333;
  font-weight: bold;
}

.title-line {
  display: block;
  width: 60px;
  height: 3px;
  background-color: #ff6700;
  margin: 10px auto 0;
}

/* 课程优势特有样式 */
.course-advantages {
  padding: 60px 0;
  background-color: #f9f9f9;
}

.advantages-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 30px;
}

.advantage-card {
  text-align: center;
  padding: 30px 20px;
  transition: all 0.3s ease;
  border: none;
}

.advantage-card:hover {
  transform: translateY(-10px);
}

.advantage-icon {
  color: #ff6700;
  margin-bottom: 20px;
}

.advantage-title {
  font-size: 18px;
  margin-bottom: 15px;
  color: #333;
}

.advantage-desc {
  color: #666;
  line-height: 1.6;
}

/* 响应式适配 */
@media (max-width: 992px) {
  .advantages-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 768px) {
  .title-text {
    font-size: 24px;
  }

  .course-advantages {
    padding: 40px 0;
  }
}

@media (max-width: 576px) {
  .advantages-grid {
    grid-template-columns: 1fr;
  }

  .advantage-card {
    padding: 20px 15px;
  }
}
</style>